import React, { useState, useEffect } from 'react'
import Topbar from '../components/Layout/Topbar'
import { Sidebar } from '../components/Layout/Sidebar'
import UserList from '../CreateUser/UserList'
import { getAllUsers } from '../supabase.config'

const Users = () => {
  const [userList, setUserList] = useState([])
  const [activeTab, setActiveTab] = useState("Client")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchUsers = async () => {
    try {
      setLoading(true)
      setError(null)

      const result = await getAllUsers()

      if (result.error) {
        console.error("Error fetching users:", result.error)
        setError(result.error.message)
        return
      }

      const rows = result.data || []
      const filteredRows = activeTab === "Client"
        ? rows.filter((user) => user.role === 'client')
        : rows.filter((user) => user.role !== 'client')

      // Transform the data to match the expected format
      const users = filteredRows.map((user) => ({
        id: user.id,
        name: user.name,
        email: user.email,
        contact: user.contact,
        companyName: user.company_name,
        gstNo: user.gst_no,
        gstDocument: user.gst_document,
        agreement: user.agreement,
        otherDoc: user.other_doc,
        insuranceType: user.insurance_type,
        companyAddress: user.company_address,
        role: user.role,
        partnerType: user.partner_type,
        walletBalance: user.wallet_balance,
        service: user.service,
        rateList: user.rate_list,
        createdAt: user.created_at,
        updatedAt: user.updated_at
      }))

      setUserList(users)
    } catch (error) {
      console.error("Error fetching users:", error)
      setError(error.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchUsers()
  }, [activeTab])

  // Refresh users function
  const refreshUsers = () => {
    fetchUsers()
  }

  return (
    <div className='flex bg-slate-100/80'>
      <Sidebar />
      <div className='flex h-[100vh] flex-1 flex-col overflow-y-scroll' >
        <Topbar />

        <UserList 
          activeTab={activeTab} 
          setActiveTab={setActiveTab} 
          userList={userList}
          loading={loading}
          error={error}
          onRefresh={refreshUsers}
        />
      </div>
    </div>
  )
}

export default Users
